import { useRef, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import {
  nextStep,
  prevStep,
  addStepsData,
} from "app/lib/store/slices/steps/jointAssetsLiabilities";
import toast from "react-hot-toast";
import MainTitle from "app/components/common/typography/MainTitle";
import SubTitle from "app/components/common/typography/SubTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import InfoTitle from "app/components/common/typography/InfoTitle";
import { useAddAssetsLiabilitiesImages } from "app/hooks/assetsLiabilities/useAddAssetsLiabilitiesImages";
import PassportImageUpload from "app/components/imagesUploads/joint/PassportImageUpload";
import PassportAndVisa from "./PassportAndVisa";
import Loader from "app/components/common/Loader";
import HasValidAustralianPassport from "app/components/common/inputs/HasValidAustralianPassport";
import FileUploadCard from "app/components/common/inputs/FileUploadCard";
import { getPresignedUrlsPromise } from "app/utils/getPresignedUrlsPromise";
import { useS3Upload } from "app/hooks/assetsLiabilities/useS3Upload";
interface FormData {
  passportImage?: File | null;
  copassportImage?: File | null;
  // in case if its not visa status is
  passport?: File | null;
  visa?: File | null;
  copassport?: File | null;
  covisa?: File | null;

  certificate?: File | null;
  medicareCard?: File | null;

  cocertificate?: File | null;
  comedicareCard?: File | null;
}
type FieldName =
  | "passport"
  | "visa"
  | "copassport"
  | "covisa"
  | "passportImage"
  | "copassportImage"
  | "certificate"
  | "medicareCard"
  | "cocertificate"
  | "comedicareCard";

const PartFive: React.FC = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const { mutate: uploadS3 } = useS3Upload();

  const { mutateAsync: uploadImages, isPending } =
    useAddAssetsLiabilitiesImages();

  const [yourisValidPassport, setYourIsValidPassport] =
    useState<boolean>(false);
  const [coisValidPassport, setCoIsValidPassport] = useState<boolean>(false);

  //  ======= visa status type =======

  const coBorrowerVisaStatus = useSelector(
    (state: RootState) => state.jointpersonalDetails?.stepsData?.formFour
  );
  const yourDetailsVisaStatus = useSelector(
    (state: RootState) => state.jointpersonalDetails?.stepsData?.formFour
  );
  const { visaStatus } = yourDetailsVisaStatus?.yourDetails || {};

  const { visaStatus: covisaStatus } =
    coBorrowerVisaStatus?.coBorrowerDetails || {};

  //  ======= End visa status type =======

  const [yourPreview, setYourPreview] = useState<string | null>(null);
  const [coPreview, setCoPreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const cofileInputRef = useRef<HTMLInputElement>(null);
  const {
    passportImage: storePassPortImage,
    copassportImage: storeCoPassPortImage,
    driverlicenseimages,
    passportVisaimages,
    certificate: storeCertificate,
    medicareCard: storeMedicareCard,
    cocertificate: storeCoCertificate,
    comedicareCard: storeCoMedicareCard,
    validAustralianPassport,
    covalidAustralianPassport,
    ...others
  } = useSelector((state: RootState) => state.jointAssetsLiabilities.stepsData);

  const savedIds = useSelector(
    (state: RootState) => state.loanTypesSteps?.savedIds
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
    setError,
    trigger,
    unregister,
  } = useForm<FormData>({
    shouldUnregister: true,
  });
  // =================== passport and visa logic ===================

  const [yourFrontPreview, setYourFrontPreview] = useState<string | null>(null);
  const [yourBackPreview, setYourBackPreview] = useState<string | null>(null);
  const [coFrontPreview, setCoFrontPreview] = useState<string | null>(null);
  const [coBackPreview, setCoBackPreview] = useState<string | null>(null);
  const frontFileInputRef = useRef<HTMLInputElement>(null);
  const backFileInputRef = useRef<HTMLInputElement>(null);
  const cofrontFileInputRef = useRef<HTMLInputElement>(null);
  const cobackFileInputRef = useRef<HTMLInputElement>(null);
  const passport = watch("passport");
  const visa = watch("visa");
  const copassport = watch("copassport");
  const covisa = watch("covisa");

  const visaPassportHandleDeleteImage = (
    type: "passport" | "visa" | "copassport" | "covisa"
  ) => {
    const previewSetters = {
      passport: setYourFrontPreview,
      visa: setYourBackPreview,
      copassport: setCoFrontPreview,
      covisa: setCoBackPreview,
    };
    const updatePreview = previewSetters[type];
    if (updatePreview) {
      dispatch(
        addStepsData({
          ...others,
          passportVisaimages: {
            ...passportVisaimages,
            [type]: "",
          },
        })
      );
      updatePreview(null);
      setValue(type, null);
    }
  };
  const visaPassporthandleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    fileType: FieldName
  ) => {
    const file = e.target.files?.[0] ?? null;
    if (!file) return;

    const type = fileType === "passport" ? "passport" : "visa";
    clearErrors(type);

    if (file.size > 5 * 1024 * 1024) {
      setError(type, {
        type: "fileSize",
        message: "File size should not exceed 5MB",
      });
      e.target.value = "";
      return;
    }
    // Validate file type
    if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
      setError(type, {
        type: "fileType",
        message: "Invalid file type. Only JPG, PNG are allowed",
      });
      e.target.value = "";
      return;
    }

    setValue(type, file, { shouldValidate: true });
    await trigger(type);
  };

  const visaPassportCohandleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    fileType: FieldName
  ) => {
    const file = e.target.files?.[0] ?? null;
    if (!file) return;

    const type = fileType === "copassport" ? "copassport" : "covisa";
    clearErrors(type);

    if (file.size > 5 * 1024 * 1024) {
      setError(type, {
        type: "fileSize",
        message: "File size should not exceed 5MB",
      });
      e.target.value = "";
      return;
    }
    // Validate file type
    if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
      setError(type, {
        type: "fileType",
        message: "Invalid file type. Only JPG, PNG are allowed",
      });
      e.target.value = "";
      return;
    }
    setValue(type, file, { shouldValidate: true });
    await trigger(type);
  };

  const visaPassporthandleFileChooseClick = (type: FieldName) => {
    if (type === "passport" && frontFileInputRef.current) {
      frontFileInputRef.current.click();
    } else if (type === "visa" && backFileInputRef.current) {
      backFileInputRef.current.click();
    }
  };
  const visaPassportCohandleFileChooseClick = (type: FieldName) => {
    if (type === "copassport" && cofrontFileInputRef.current) {
      cofrontFileInputRef.current.click();
    } else if (type === "covisa" && cobackFileInputRef.current) {
      cobackFileInputRef.current.click();
    }
  };

  useEffect(() => {
    const images = {
      passport,
      visa,
      copassport,
      covisa,
    };

    Object.entries(images).forEach(([key, file]) => {
      if (file instanceof File) {
        const objectUrl = URL.createObjectURL(file);

        // Set preview dynamically
        switch (key) {
          case "passport":
            setYourFrontPreview(objectUrl);
            break;
          case "visa":
            setYourBackPreview(objectUrl);
            break;
          case "copassport":
            setCoFrontPreview(objectUrl);
            break;
          case "covisa":
            setCoBackPreview(objectUrl);
            break;
        }

        // Cleanup function to revoke object URLs
        return () => URL.revokeObjectURL(objectUrl);
      } else {
        // Fallback to existing stored image
        switch (key) {
          case "passport":
            setYourFrontPreview(passportVisaimages?.passport || null);
            break;
          case "visa":
            setYourBackPreview(passportVisaimages?.visa || null);
            break;
          case "copassport":
            setCoFrontPreview(passportVisaimages?.copassport || null);
            break;
          case "covisa":
            setCoBackPreview(passportVisaimages?.covisa || null);
            break;
        }
      }
    });
  }, [
    passport,
    visa,
    copassport,
    covisa,
    passportVisaimages?.passport,
    passportVisaimages?.visa,
    passportVisaimages?.copassport,
    passportVisaimages?.covisa,
  ]);

  // =================== End passport and visa logic ===============

  const selectedFile = watch("passportImage");
  const coselectedFile = watch("copassportImage");

  // const isCitizen = visaStatus === "Citizen";
  // const isCoCitizen = covisaStatus === "Citizen";


  const onSubmit = async (data: FormData) => {
    const {
      copassportImage,
      passportImage,
      passport,
      visa,
      copassport,
      covisa,
      certificate,
      medicareCard,
      cocertificate,
      comedicareCard,
    } = data || {};

    const isCitizen = visaStatus === "Citizen";
    const isCoCitizen = covisaStatus === "Citizen";

    const isyourValidPassport = yourisValidPassport;
    const iscoValidPassport = coisValidPassport;

    if (isCitizen && isCoCitizen) {
      if (!isyourValidPassport && !iscoValidPassport) {
        if (
          !(passportImage instanceof File) &&
          !(copassportImage instanceof File)
        ) {
          dispatch(nextStep());
          return;
        }

        const yourUploadData: Record<string, File> = {};
        const coUploadData: Record<string, File> = {};
        const yourDocumentTypes: string[] = [];
        const coDocumentTypes: string[] = [];

        if (passportImage instanceof File) {
          yourDocumentTypes.push("passport");
          yourUploadData.passportImage = passportImage;
        }
        if (copassportImage instanceof File) {
          coDocumentTypes.push("passport");
          coUploadData.passport = copassportImage;
        }
        if (
          Object.keys(coUploadData).length === 0 &&
          Object.keys(yourUploadData).length === 0
        ) {
          dispatch(nextStep());
          return;
        }

        try {
          setIsLoading(true);
          let yourPresignedData: any = null;
          let coPresignedData: any = null;
          const presignedRequests: Promise<any>[] = [];

          if (yourDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.applicantID}/presigned-urls`,
                data: { documentTypes: yourDocumentTypes },
              }).then((res) => {
                yourPresignedData = res;
              })
            );
          }
          if (coDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.secondApplicantID}/presigned-urls`,
                data: { documentTypes: coDocumentTypes },
              }).then((res) => {
                coPresignedData = res;
              })
            );
          }
          await Promise.all(presignedRequests);

          const yourMetadata: Record<string, any> = {};
          const coMetadata: Record<string, any> = {};

          if (passportImage instanceof File && yourPresignedData?.passport) {
            const { url, key } = yourPresignedData?.passport || {};
            await uploadToS3(url, passportImage);
            yourMetadata["passport"] = {
              key,
              fileName: passportImage.name,
              mimeType: passportImage.type,
            };
          }
          if (copassportImage instanceof File && coPresignedData?.passport) {
            const { url, key } = coPresignedData?.passport || {};
            await uploadToS3(url, copassportImage);
            coMetadata["passport"] = {
              key,
              fileName: copassportImage.name,
              mimeType: copassportImage.type,
            };
          }
          const uploadRequests: Promise<any>[] = [];
          let hasYourUpload = Object.keys(yourMetadata).length > 0;
          let hasCoUpload = Object.keys(coMetadata).length > 0;

          if (Object.keys(yourMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.applicantID}/passport`,
                data: yourMetadata,
              })
            );
          }

          if (Object.keys(coMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.secondApplicantID}/passport`,
                data: coMetadata,
              })
            );
          }
          const uploadResponses = await Promise.all(uploadRequests);
          let yourResponse: any = null;
          let coResponse: any = null;

          if (hasYourUpload && hasCoUpload) {
            [yourResponse, coResponse] = uploadResponses;
          } else if (hasYourUpload) {
            yourResponse = uploadResponses[0];
          } else if (hasCoUpload) {
            coResponse = uploadResponses[0];
          }

          const updatedData: any = { ...others };
          if (passportImage instanceof File && yourResponse?.url) {
            updatedData.passportImage = yourResponse?.url;
          }
          if (copassportImage instanceof File && coResponse?.url) {
            updatedData.copassportImage = coResponse?.url;
          }
          dispatch(addStepsData(updatedData));
          setIsLoading(false);
          dispatch(nextStep());
        } catch (error: any) {
          setIsLoading(false);
          toast.error(
            error?.response?.data?.message || "Something went wrong."
          );
        }
      } else if (isyourValidPassport && !iscoValidPassport) {
        const noFilesUploaded = [
          copassportImage,
          certificate,
          medicareCard,
        ].every((file) => !(file instanceof File));
        if (noFilesUploaded) {
          dispatch(nextStep());
          return;
        }

        const yourUploadData: Record<string, File> = {};
        const coUploadData: Record<string, File> = {};
        const yourDocumentTypes: string[] = [];
        const coDocumentTypes: string[] = [];

        if (copassportImage instanceof File) {
          yourDocumentTypes.push("passport");
          yourUploadData.passport = copassportImage;
        }

        if (certificate instanceof File) {
          coDocumentTypes.push("birth_or_citizenship_certificate");
          coUploadData.certificate = certificate;
        }
        if (medicareCard instanceof File) {
          coDocumentTypes.push("medicare_card");
          coUploadData.medicareCard = medicareCard;
        }
        if (
          Object.keys(coUploadData).length === 0 &&
          Object.keys(yourUploadData).length === 0
        ) {
          dispatch(nextStep());
          return;
        }

        try {
          setIsLoading(true);
          let yourPresignedData: any = null;
          let coPresignedData: any = null;
          const presignedRequests: Promise<any>[] = [];
          if (yourDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.applicantID}/presigned-urls`,
                data: { documentTypes: yourDocumentTypes },
              }).then((res) => {
                yourPresignedData = res;
              })
            );
          }
          if (coDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.secondApplicantID}/presigned-urls`,
                data: { documentTypes: coDocumentTypes },
              }).then((res) => {
                coPresignedData = res;
              })
            );
          }

          await Promise.all(presignedRequests);
          const yourMetadata: Record<string, any> = {};
          const coMetadata: Record<string, any> = {};

          if (copassportImage instanceof File && yourPresignedData?.passport) {
            const { url, key } = yourPresignedData?.passport || {};
            await uploadToS3(url, copassportImage);
            yourMetadata["passport"] = {
              key,
              fileName: copassportImage.name,
              mimeType: copassportImage.type,
            };
          }
          if (
            certificate instanceof File &&
            coPresignedData?.birth_or_citizenship_certificate
          ) {
            const { url, key } =
              coPresignedData?.birth_or_citizenship_certificate || {};
            await uploadToS3(url, certificate);
            coMetadata["certificate"] = {
              key,
              fileName: certificate.name,
              mimeType: certificate.type,
            };
          }

          if (medicareCard instanceof File && coPresignedData?.medicare_card) {
            const { url, key } = coPresignedData?.medicare_card || {};
            await uploadToS3(url, medicareCard);
            coMetadata["medicareCard"] = {
              key,
              fileName: medicareCard.name,
              mimeType: medicareCard.type,
            };
          }
          const uploadRequests: Promise<any>[] = [];
          let hasYourUpload = Object.keys(yourMetadata).length > 0;
          let hasCoUpload = Object.keys(coMetadata).length > 0;
          if (Object.keys(yourMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.applicantID}/passport`,
                data: yourMetadata,
              })
            );
          }
          if (Object.keys(coMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.secondApplicantID}/identity-docs`,
                data: coMetadata,
              })
            );
          }
          const uploadResponses = await Promise.all(uploadRequests);
          let yourResponse: any = {};
          let coResponse: any[] = [];
          let certificateUrl = "";
          let medicareCardUrl = "";
          let passportImageUrl = "";

          if (hasYourUpload && hasCoUpload) {
            [yourResponse, coResponse] = uploadResponses;
          } else if (hasYourUpload) {
            [yourResponse] = uploadResponses;
          } else if (hasCoUpload) {
            [coResponse] = uploadResponses;
          }
          if (coResponse?.length > 0) {
            coResponse?.forEach((item: any) => {
              if (item.type === "birth_or_citizenship_certificate") {
                certificateUrl = item.url;
              } else if (item.type === "medicare_card") {
                medicareCardUrl = item.url;
              }
            });
          }

          if (yourResponse && typeof yourResponse === "object") {
            if ("passport" in yourResponse) {
              passportImageUrl = yourResponse.passport?.url || "";
            } else if ("url" in yourResponse) {
              passportImageUrl = yourResponse.url;
            }
          }

          dispatch(
            addStepsData({
              ...others,
              ...(certificateUrl && { certificate: certificateUrl }),
              ...(medicareCardUrl && { medicareCard: medicareCardUrl }),
              ...(passportImageUrl && {
                copassportImage: passportImageUrl || storeCoPassPortImage,
              }),
              validAustralianPassport: yourisValidPassport || false,
            })
          );
          dispatch(nextStep());
          setIsLoading(false);
        } catch (error: any) {
          setIsLoading(false);
          toast.error(
            error?.response?.data?.message || "Something went wrong."
          );
        }
      } else if (!isyourValidPassport && iscoValidPassport) {
        const noFilesUploaded = [
          passportImage,
          cocertificate,
          comedicareCard,
        ].every((file) => !(file instanceof File));
        if (noFilesUploaded) {
          dispatch(nextStep());
          return;
        }

        const yourUploadData: Record<string, File> = {};
        const coUploadData: Record<string, File> = {};
        const yourDocumentTypes: string[] = [];
        const coDocumentTypes: string[] = [];

        if (passportImage instanceof File) {
          yourDocumentTypes.push("passport");
          yourUploadData.passport = passportImage;
        }

        if (cocertificate instanceof File) {
          coDocumentTypes.push("birth_or_citizenship_certificate");
          coUploadData.certificate = cocertificate;
        }
        if (comedicareCard instanceof File) {
          coDocumentTypes.push("medicare_card");
          coUploadData.medicareCard = comedicareCard;
        }

        if (
          Object.keys(coUploadData).length === 0 &&
          Object.keys(yourUploadData).length === 0
        ) {
          dispatch(nextStep());
          return;
        }

        try {
          setIsLoading(true);
          let yourPresignedData: any = null;
          let coPresignedData: any = null;
          const presignedRequests: Promise<any>[] = [];

          if (yourDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.applicantID}/presigned-urls`,
                data: { documentTypes: yourDocumentTypes },
              }).then((res) => {
                yourPresignedData = res;
              })
            );
          }
          if (coDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.secondApplicantID}/presigned-urls`,
                data: { documentTypes: coDocumentTypes },
              }).then((res) => {
                coPresignedData = res;
              })
            );
          }

          await Promise.all(presignedRequests);
          const yourMetadata: Record<string, any> = {};
          const coMetadata: Record<string, any> = {};

          if (passportImage instanceof File && yourPresignedData?.passport) {
            const { url, key } = yourPresignedData?.passport || {};
            await uploadToS3(url, passportImage);
            yourMetadata["passport"] = {
              key,
              fileName: passportImage.name,
              mimeType: passportImage.type,
            };
          }
          if (
            cocertificate instanceof File &&
            coPresignedData?.birth_or_citizenship_certificate
          ) {
            const { url, key } =
              coPresignedData?.birth_or_citizenship_certificate || {};
            await uploadToS3(url, cocertificate);
            coMetadata["certificate"] = {
              key,
              fileName: cocertificate.name,
              mimeType: cocertificate.type,
            };
          }

          if (
            comedicareCard instanceof File &&
            coPresignedData?.medicare_card
          ) {
            const { url, key } = coPresignedData?.medicare_card || {};
            await uploadToS3(url, comedicareCard);
            coMetadata["medicareCard"] = {
              key,
              fileName: comedicareCard.name,
              mimeType: comedicareCard.type,
            };
          }
          const uploadRequests: Promise<any>[] = [];
          let hasYourUpload = Object.keys(yourMetadata).length > 0;
          let hasCoUpload = Object.keys(coMetadata).length > 0;

          if (Object.keys(yourMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.applicantID}/passport`,
                data: yourMetadata,
              })
            );
          }

          if (Object.keys(coMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.secondApplicantID}/identity-docs`,
                data: coMetadata,
              })
            );
          }
          const uploadResponses = await Promise.all(uploadRequests);
          let yourResponse: any = {};
          let coResponse: any[] = [];
          // Extract values from coResponse array
          let cocertificateUrl = "";
          let comedicareCardUrl = "";
          let passportImageUrl = "";

          if (hasYourUpload && hasCoUpload) {
            [yourResponse, coResponse] = uploadResponses;
          } else if (hasYourUpload) {
            [yourResponse] = uploadResponses;
          } else if (hasCoUpload) {
            [coResponse] = uploadResponses;
          }
          if (coResponse?.length > 0) {
            coResponse?.forEach((item: any) => {
              if (item.type === "birth_or_citizenship_certificate") {
                cocertificateUrl = item.url;
              } else if (item.type === "medicare_card") {
                comedicareCardUrl = item.url;
              }
            });
          }

          if (yourResponse && typeof yourResponse === "object") {
            if ("passport" in yourResponse) {
              passportImageUrl = yourResponse.passport?.url || "";
            } else if ("url" in yourResponse) {
              passportImageUrl = yourResponse.url;
            }
          }

          dispatch(
            addStepsData({
              ...others,
              ...(comedicareCardUrl && { comedicareCard: comedicareCardUrl }),
              ...(cocertificateUrl && { cocertificate: cocertificateUrl }),
              ...(passportImageUrl && {
                passportImage: passportImageUrl || storePassPortImage,
              }),
              covalidAustralianPassport: coisValidPassport || false,
            })
          );
          dispatch(nextStep());

          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
        }
      } else {
        const noFilesUploaded = [
          certificate,
          medicareCard,
          cocertificate,
          comedicareCard,
        ].every((file) => !(file instanceof File));

        if (noFilesUploaded) {
          dispatch(nextStep());
          return;
        }

        const yourUploadData: Record<string, File> = {};
        const yourDocumentTypes: string[] = [];
        const coUploadData: Record<string, File> = {};
        const coDocumentTypes: string[] = [];

        if (certificate instanceof File) {
          yourDocumentTypes.push("birth_or_citizenship_certificate");
          yourUploadData.certificate = certificate;
        }
        if (medicareCard instanceof File) {
          yourUploadData.medicareCard = medicareCard;
          yourDocumentTypes.push("medicare_card");
        }
        if (cocertificate instanceof File) {
          coDocumentTypes.push("birth_or_citizenship_certificate");
          coUploadData.certificate = cocertificate;
        }
        if (comedicareCard instanceof File) {
          coDocumentTypes.push("medicare_card");
          coUploadData.medicareCard = comedicareCard;
        }
        if (
          Object.keys(coUploadData).length === 0 &&
          Object.keys(yourUploadData).length === 0
        ) {
          dispatch(nextStep());
          return;
        }

        try {
          setIsLoading(true);
          let yourPresignedData: any = null;
          let coPresignedData: any = null;
          const presignedRequests: Promise<any>[] = [];

          if (yourDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.applicantID}/presigned-urls`,
                data: { documentTypes: yourDocumentTypes },
              }).then((res) => {
                yourPresignedData = res;
              })
            );
          }
          if (coDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.secondApplicantID}/presigned-urls`,
                data: { documentTypes: coDocumentTypes },
              }).then((res) => {
                coPresignedData = res;
              })
            );
          }
          await Promise.all(presignedRequests);

          const yourMetadata: Record<string, any> = {};
          const coMetadata: Record<string, any> = {};

          if (
            certificate instanceof File &&
            yourPresignedData?.birth_or_citizenship_certificate
          ) {
            const { url, key } =
              yourPresignedData?.birth_or_citizenship_certificate || {};
            await uploadToS3(url, certificate);
            yourMetadata["certificate"] = {
              key,
              fileName: certificate.name,
              mimeType: certificate.type,
            };
          }

          if (
            medicareCard instanceof File &&
            yourPresignedData?.medicare_card
          ) {
            const { url, key } = yourPresignedData?.medicare_card || {};
            await uploadToS3(url, medicareCard);
            yourMetadata["medicareCard"] = {
              key,
              fileName: medicareCard.name,
              mimeType: medicareCard.type,
            };
          }

          if (
            cocertificate instanceof File &&
            coPresignedData?.birth_or_citizenship_certificate
          ) {
            const { url, key } =
              coPresignedData?.birth_or_citizenship_certificate || {};
            await uploadToS3(url, cocertificate);
            coMetadata["certificate"] = {
              key,
              fileName: cocertificate.name,
              mimeType: cocertificate.type,
            };
          }

          if (
            comedicareCard instanceof File &&
            coPresignedData?.medicare_card
          ) {
            const { url, key } = coPresignedData?.medicare_card || {};
            await uploadToS3(url, comedicareCard);
            coMetadata["medicareCard"] = {
              key,
              fileName: comedicareCard.name,
              mimeType: comedicareCard.type,
            };
          }
          const uploadRequests: Promise<any>[] = [];
          let hasYourUpload = Object.keys(yourMetadata).length > 0;
          let hasCoUpload = Object.keys(coMetadata).length > 0;

          if (Object.keys(yourMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.applicantID}/identity-docs`,
                data: yourMetadata,
              })
            );
          }

          if (Object.keys(coMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.secondApplicantID}/identity-docs`,
                data: coMetadata,
              })
            );
          }
          const uploadResponses = await Promise.all(uploadRequests);
          let yourResponse: any[] = [];
          let coResponse: any[] = [];
          if (hasYourUpload && hasCoUpload) {
            [yourResponse, coResponse] = uploadResponses;
          } else if (hasYourUpload) {
            [yourResponse] = uploadResponses;
          } else if (hasCoUpload) {
            [coResponse] = uploadResponses;
          }
          const valuesToStore: any = {
            ...others,
            validAustralianPassport: yourisValidPassport || false,
            covalidAustralianPassport: coisValidPassport || false,
          };
          if (yourResponse?.length > 0) {
            yourResponse?.forEach((item: any) => {
              if (item.type === "birth_or_citizenship_certificate") {
                valuesToStore.certificate = item.url;
              } else if (item.type === "medicare_card") {
                valuesToStore.medicareCard = item.url;
              }
            });
          }
          if (coResponse?.length > 0) {
            coResponse?.forEach((item: any) => {
              if (item.type === "birth_or_citizenship_certificate") {
                valuesToStore.cocertificate = item.url;
              } else if (item.type === "medicare_card") {
                valuesToStore.comedicareCard = item.url;
              }
            });
          }

          dispatch(addStepsData(valuesToStore));
          dispatch(nextStep());
          setIsLoading(false);
        } catch (error: any) {
          setIsLoading(false);
          toast.error(
            error?.response?.data?.message || "Something went wrong."
          );
        }
      }
    } else if (isCitizen && !isCoCitizen) {
      if (!isyourValidPassport) {
        const noFilesUploaded = [passportImage, copassport, covisa].every(
          (file) => !(file instanceof File)
        );
        if (noFilesUploaded) {
          dispatch(nextStep());
          return;
        }
        const yourUploadData: Record<string, File> = {};
        const coUploadData: Record<string, File> = {};
        const yourDocumentTypes: string[] = [];
        const coDocumentTypes: string[] = [];

        if (passportImage instanceof File) {
          yourDocumentTypes.push("passport");
          yourUploadData.passport = passportImage;
        }
        if (copassport instanceof File) {
          coDocumentTypes.push("passport");
          coUploadData.passport = copassport;
        }
        if (covisa instanceof File) {
          coDocumentTypes.push("visa");
          coUploadData.visa = covisa;
        }

        if (
          Object.keys(coUploadData).length === 0 &&
          Object.keys(yourUploadData).length === 0
        ) {
          dispatch(nextStep());
          return;
        }

        try {
          setIsLoading(true);
          let yourPresignedData: any = null;
          let coPresignedData: any = null;
          const presignedRequests: Promise<any>[] = [];

          if (yourDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.applicantID}/presigned-urls`,
                data: { documentTypes: yourDocumentTypes },
              }).then((res) => {
                yourPresignedData = res;
              })
            );
          }
          if (coDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.secondApplicantID}/presigned-urls`,
                data: { documentTypes: coDocumentTypes },
              }).then((res) => {
                coPresignedData = res;
              })
            );
          }

          await Promise.all(presignedRequests);
          const yourMetadata: Record<string, any> = {};
          const coMetadata: Record<string, any> = {};

          if (passportImage instanceof File && yourPresignedData?.passport) {
            const { url, key } = yourPresignedData?.passport || {};
            await uploadToS3(url, passportImage);
            yourMetadata["passport"] = {
              key,
              fileName: passportImage.name,
              mimeType: passportImage.type,
            };
          }
          // passportImage, copassport, covisa
          if (copassport instanceof File && coPresignedData?.passport) {
            const { url, key } = coPresignedData?.passport || {};
            await uploadToS3(url, copassport);
            coMetadata["passport"] = {
              key,
              fileName: copassport.name,
              mimeType: copassport.type,
            };
          }

          if (covisa instanceof File && coPresignedData?.visa) {
            const { url, key } = coPresignedData?.visa || {};
            await uploadToS3(url, covisa);
            coMetadata["visa"] = {
              key,
              fileName: covisa.name,
              mimeType: covisa.type,
            };
          }
          const uploadRequests: Promise<any>[] = [];
          let hasYourUpload = Object.keys(yourMetadata).length > 0;
          let hasCoUpload = Object.keys(coMetadata).length > 0;
          if (Object.keys(yourMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.applicantID}/passport`,
                data: yourMetadata,
              })
            );
          }
          if (Object.keys(coMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.secondApplicantID}/visa-passport`,
                data: coMetadata,
              })
            );
          }
          const uploadResponses = await Promise.all(uploadRequests);
          let yourResponse: any = {};
          let coResponse: any[] = [];
          let passportImageUrl = "";
          let copassportUrl = "";
          let covisaUrl = "";

          if (hasYourUpload && hasCoUpload) {
            [yourResponse, coResponse] = uploadResponses;
          } else if (hasYourUpload) {
            [yourResponse] = uploadResponses;
          } else if (hasCoUpload) {
            [coResponse] = uploadResponses;
          }
          if (
            yourResponse &&
            typeof yourResponse === "object" &&
            yourResponse?.url
          ) {
            passportImageUrl = yourResponse?.url;
          }
          if (coResponse?.length > 0) {
            coResponse?.forEach((item: any) => {
              if (item.type === "passport") {
                copassportUrl = item.url;
              } else if (item.type === "visa") {
                covisaUrl = item.url;
              }
            });
          }

          dispatch(
            addStepsData({
              ...others,
              passportImage: passportImageUrl || storePassPortImage,
              passportVisaimages: {
                ...passportVisaimages,
                ...(copassportUrl && { copassport: copassportUrl }),
                ...(covisaUrl && { covisa: covisaUrl }),
              },
            })
          );
          dispatch(nextStep());
          setIsLoading(false);
        } catch (error: any) {
          setIsLoading(false);
          toast.error(
            error?.response?.data?.message || "Something went wrong."
          );
        }
      } else {
        const noFilesUploaded = [
          certificate,
          medicareCard,
          copassport,
          covisa,
        ].every((file) => !(file instanceof File));
        if (noFilesUploaded) {
          dispatch(nextStep());
          return;
        }

        const yourUploadData: Record<string, File> = {};
        const coUploadData: Record<string, File> = {};
        const yourDocumentTypes: string[] = [];
        const coDocumentTypes: string[] = [];

        if (certificate instanceof File) {
          yourDocumentTypes.push("birth_or_citizenship_certificate");
          coUploadData.certificate = certificate;
        }
        if (medicareCard instanceof File) {
          yourDocumentTypes.push("medicare_card");
          coUploadData.medicareCard = medicareCard;
        }

        if (copassport instanceof File) {
          coDocumentTypes.push("passport");
          yourUploadData.passport = copassport;
        }
        if (covisa instanceof File) {
          yourUploadData.visa = covisa;
          coDocumentTypes.push("visa");
        }

        if (
          Object.keys(coUploadData).length === 0 &&
          Object.keys(yourUploadData).length === 0
        ) {
          dispatch(nextStep());
          return;
        }

        try {
          setIsLoading(true);
          let yourPresignedData: any = null;
          let coPresignedData: any = null;
          const presignedRequests: Promise<any>[] = [];

          if (yourDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.applicantID}/presigned-urls`,
                data: { documentTypes: yourDocumentTypes },
              }).then((res) => {
                yourPresignedData = res;
              })
            );
          }
          if (coDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.secondApplicantID}/presigned-urls`,
                data: { documentTypes: coDocumentTypes },
              }).then((res) => {
                coPresignedData = res;
              })
            );
          }

          await Promise.all(presignedRequests);
          const yourMetadata: Record<string, any> = {};
          const coMetadata: Record<string, any> = {};

          if (
            certificate instanceof File &&
            yourPresignedData?.birth_or_citizenship_certificate
          ) {
            const { url, key } =
              yourPresignedData?.birth_or_citizenship_certificate || {};
            await uploadToS3(url, certificate);
            yourMetadata["certificate"] = {
              key,
              fileName: certificate.name,
              mimeType: certificate.type,
            };
          }

          if (
            medicareCard instanceof File &&
            yourPresignedData?.medicare_card
          ) {
            const { url, key } = yourPresignedData?.medicare_card || {};
            await uploadToS3(url, medicareCard);
            yourMetadata["medicareCard"] = {
              key,
              fileName: medicareCard.name,
              mimeType: medicareCard.type,
            };
          }
          if (copassport instanceof File && coPresignedData?.passport) {
            const { url, key } = coPresignedData?.passport || {};
            await uploadToS3(url, copassport);
            coMetadata["passport"] = {
              key,
              fileName: copassport.name,
              mimeType: copassport.type,
            };
          }

          if (covisa instanceof File && coPresignedData?.visa) {
            const { url, key } = coPresignedData?.visa || {};
            await uploadToS3(url, covisa);
            coMetadata["visa"] = {
              key,
              fileName: covisa.name,
              mimeType: covisa.type,
            };
          }

          const uploadRequests: Promise<any>[] = [];
          let hasYourUpload = Object.keys(yourMetadata).length > 0;
          let hasCoUpload = Object.keys(coMetadata).length > 0;

          if (Object.keys(yourMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.applicantID}/identity-docs`,
                data: yourMetadata,
              })
            );
          }

          if (Object.keys(coMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.secondApplicantID}/visa-passport`,
                data: coMetadata,
              })
            );
          }
          const uploadResponses = await Promise.all(uploadRequests);
          let yourResponse: any = {};
          let coResponse: any[] = [];
          if (hasYourUpload && hasCoUpload) {
            [yourResponse, coResponse] = uploadResponses;
          } else if (hasYourUpload) {
            [yourResponse] = uploadResponses;
          } else if (hasCoUpload) {
            [coResponse] = uploadResponses;
          }
          // const dataToStore: Record<string, string> = {};

          // if (yourResponse?.length > 0) {
          //   yourResponse?.forEach((item: any) => {
          //     if (item.type === "birth_or_citizenship_certificate")
          //       dataToStore.certificate = item.url;
          //     if (item.type === "medicare_card")
          //       dataToStore.medicareCard = item.url;
          //   });
          // }

          // if (coResponse?.length > 0) {
          //   coResponse?.forEach((item: any) => {
          //     if (item.type === "passport")
          //       dataToStore.cocertificate = item.url;
          //     if (item.type === "visa") dataToStore.comedicareCard = item.url;
          //   });
          // }

          const dataToStore: Record<string, any> = {
            passportVisaimages: {
              ...passportVisaimages,
            },
          };
          if (yourResponse?.length > 0) {
            yourResponse?.forEach((item: any) => {
              if (item.type === "birth_or_citizenship_certificate")
                dataToStore.cocertificate = item.url;
              if (item.type === "medicare_card")
                dataToStore.comedicareCard = item.url;
            });
          }

          if (coResponse?.length > 0) {
            coResponse?.forEach((item: any) => {
              if (item.type === "passport")
                dataToStore.passportVisaimages.copassport = item.url;
              if (item.type === "visa")
                dataToStore.passportVisaimages.covisa = item.url;
            });
          }

          dispatch(
            addStepsData({
              ...others,
              passportVisaimages: dataToStore.passportVisaimages,
              certificate: dataToStore.cocertificate ?? storeCertificate,
              medicareCard: dataToStore.comedicareCard ?? storeMedicareCard,
              validAustralianPassport: yourisValidPassport || false,
              covalidAustralianPassport: coisValidPassport || false,
            })
          );

          dispatch(nextStep());
          setIsLoading(false);
        } catch (error: any) {
          setIsLoading(false);
          toast.error(
            error?.response?.data?.message || "Something went wrong."
          );
        }
      }
    } else if (!isCitizen && isCoCitizen) {
      if (!iscoValidPassport) {
        const noFilesUploaded = [passport, visa, copassportImage].every(
          (file) => !(file instanceof File)
        );
        if (noFilesUploaded) {
          dispatch(nextStep());
          return;
        }

        const yourUploadData: Record<string, File> = {};
        const coUploadData: Record<string, File> = {};
        const yourDocumentTypes: string[] = [];
        const coDocumentTypes: string[] = [];

        if (passport instanceof File) {
          yourDocumentTypes.push("passport");
          yourUploadData.passport = passport;
        }
        if (visa instanceof File) {
          yourDocumentTypes.push("visa");
          yourUploadData.visa = visa;
        }

        if (copassportImage instanceof File) {
          coDocumentTypes.push("passport");
          coUploadData.passport = copassportImage;
        }

        if (
          Object.keys(coUploadData).length === 0 &&
          Object.keys(yourUploadData).length === 0
        ) {
          dispatch(nextStep());
          return;
        }

        try {
          setIsLoading(true);
          let yourPresignedData: any = null;
          let coPresignedData: any = null;
          const presignedRequests: Promise<any>[] = [];

          if (yourDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.applicantID}/presigned-urls`,
                data: { documentTypes: yourDocumentTypes },
              }).then((res) => {
                yourPresignedData = res;
              })
            );
          }
          if (coDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.secondApplicantID}/presigned-urls`,
                data: { documentTypes: coDocumentTypes },
              }).then((res) => {
                coPresignedData = res;
              })
            );
          }

          await Promise.all(presignedRequests);
          const yourMetadata: Record<string, any> = {};
          const coMetadata: Record<string, any> = {};

          if (passport instanceof File && yourPresignedData?.passport) {
            const { url, key } = yourPresignedData?.passport || {};
            await uploadToS3(url, passport);
            yourMetadata["passport"] = {
              key,
              fileName: passport.name,
              mimeType: passport.type,
            };
          }

          if (visa instanceof File && yourPresignedData?.visa) {
            const { url, key } = yourPresignedData?.visa || {};
            await uploadToS3(url, visa);
            yourMetadata["visa"] = {
              key,
              fileName: visa.name,
              mimeType: visa.type,
            };
          }
          if (copassportImage instanceof File && coPresignedData?.passport) {
            const { url, key } = coPresignedData?.passport || {};
            await uploadToS3(url, copassportImage);
            coMetadata["passport"] = {
              key,
              fileName: copassportImage.name,
              mimeType: copassportImage.type,
            };
          }
          const uploadRequests: Promise<any>[] = [];
          let hasYourUpload = Object.keys(yourMetadata).length > 0;
          let hasCoUpload = Object.keys(coMetadata).length > 0;
          if (Object.keys(yourMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.secondApplicantID}/visa-passport`,
                data: yourMetadata,
              })
            );
          }
          if (Object.keys(coMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.applicantID}/passport`,
                data: coMetadata,
              })
            );
          }
          const uploadResponses = await Promise.all(uploadRequests);
          let yourResponse: any[] = [];
          let coResponse: any = {};
          let copassportImageUrl = "";
          let passportUrl = "";
          let visaUrl = "";

          if (hasYourUpload && hasCoUpload) {
            [yourResponse, coResponse] = uploadResponses;
          } else if (hasYourUpload) {
            [yourResponse] = uploadResponses;
          } else if (hasCoUpload) {
            [coResponse] = uploadResponses;
          }
          if (coResponse && typeof coResponse === "object" && coResponse?.url) {
            copassportImageUrl = coResponse?.url;
          }

          yourResponse?.forEach((item: any) => {
            if (item.type === "passport") {
              passportUrl = item.url;
            } else if (item.type === "visa") {
              visaUrl = item.url;
            }
          });

          dispatch(
            addStepsData({
              ...others,
              copassportImage: copassportImageUrl || storeCoPassPortImage || "",
              passportVisaimages: {
                ...passportVisaimages,
                ...(passportUrl && { passport: passportUrl }),
                ...(visaUrl && { visa: visaUrl }),
              },
            })
          );
          dispatch(nextStep());
          setIsLoading(false);
        } catch (error: any) {
          setIsLoading(false);
          toast.error(
            error?.response?.data?.message || "Something went wrong."
          );
        }
      } else {
        const noFilesUploaded = [
          comedicareCard,
          cocertificate,
          passport,
          visa,
        ].every((file) => !(file instanceof File));
        if (noFilesUploaded) {
          dispatch(nextStep());
          return;
        }
        const yourUploadData: Record<string, File> = {};
        const coUploadData: Record<string, File> = {};
        const yourDocumentTypes: string[] = [];
        const coDocumentTypes: string[] = [];

        if (passport instanceof File) {
          yourDocumentTypes.push("passport");
          yourUploadData.passport = passport;
        }
        if (visa instanceof File) {
          yourUploadData.visa = visa;
          yourDocumentTypes.push("visa");
        }
        if (cocertificate instanceof File) {
          coDocumentTypes.push("birth_or_citizenship_certificate");
          coUploadData.certificate = cocertificate;
        }
        if (comedicareCard instanceof File) {
          coDocumentTypes.push("medicare_card");
          coUploadData.medicareCard = comedicareCard;
        }

        if (
          Object.keys(coUploadData).length === 0 &&
          Object.keys(yourUploadData).length === 0
        ) {
          dispatch(nextStep());
          return;
        }

        try {
          setIsLoading(true);
          let yourPresignedData: any = null;
          let coPresignedData: any = null;
          const presignedRequests: Promise<any>[] = [];

          if (yourDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.applicantID}/presigned-urls`,
                data: { documentTypes: yourDocumentTypes },
              }).then((res) => {
                yourPresignedData = res;
              })
            );
          }
          if (coDocumentTypes.length > 0) {
            presignedRequests.push(
              getPresignedUrlsPromise({
                url: `/document/${savedIds.secondApplicantID}/presigned-urls`,
                data: { documentTypes: coDocumentTypes },
              }).then((res) => {
                coPresignedData = res;
              })
            );
          }
          await Promise.all(presignedRequests);
          const yourMetadata: Record<string, any> = {};
          const coMetadata: Record<string, any> = {};
          if (passport instanceof File && yourPresignedData?.passport) {
            const { url, key } = yourPresignedData?.passport || {};
            await uploadToS3(url, passport);
            yourMetadata["passport"] = {
              key,
              fileName: passport.name,
              mimeType: passport.type,
            };
          }

          if (visa instanceof File && yourPresignedData?.visa) {
            const { url, key } = yourPresignedData?.visa || {};
            await uploadToS3(url, visa);
            yourMetadata["visa"] = {
              key,
              fileName: visa.name,
              mimeType: visa.type,
            };
          }
          if (
            cocertificate instanceof File &&
            coPresignedData?.birth_or_citizenship_certificate
          ) {
            const { url, key } =
              coPresignedData?.birth_or_citizenship_certificate || {};
            await uploadToS3(url, cocertificate);
            coMetadata["certificate"] = {
              key,
              fileName: cocertificate.name,
              mimeType: cocertificate.type,
            };
          }

          if (
            comedicareCard instanceof File &&
            coPresignedData?.medicare_card
          ) {
            const { url, key } = coPresignedData?.medicare_card || {};
            await uploadToS3(url, comedicareCard);
            coMetadata["medicareCard"] = {
              key,
              fileName: comedicareCard.name,
              mimeType: comedicareCard.type,
            };
          }
          const uploadRequests: Promise<any>[] = [];
          let hasYourUpload = Object.keys(yourMetadata).length > 0;
          let hasCoUpload = Object.keys(coMetadata).length > 0;

          if (Object.keys(yourMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.applicantID}/visa-passport`,
                data: yourMetadata,
              })
            );
          }

          if (Object.keys(coMetadata).length > 0) {
            uploadRequests.push(
              uploadImages({
                url: `/document/${savedIds.secondApplicantID}/identity-docs`,
                data: coMetadata,
              })
            );
          }

          const uploadResponses = await Promise.all(uploadRequests);
          let yourResponse: any = {};
          let coResponse: any[] = [];
          if (hasYourUpload && hasCoUpload) {
            [yourResponse, coResponse] = uploadResponses;
          } else if (hasYourUpload) {
            [yourResponse] = uploadResponses;
          } else if (hasCoUpload) {
            [coResponse] = uploadResponses;
          }
          const dataToStore: Record<string, any> = {
            passportVisaimages: {
              ...passportVisaimages,
            },
          };
          if (yourResponse?.length > 0) {
            yourResponse?.forEach((item: any) => {
              if (item.type === "passport")
                dataToStore.passportVisaimages.passport = item.url;
              if (item.type === "visa")
                dataToStore.passportVisaimages.visa = item.url;
            });
          }
          if (coResponse?.length > 0) {
            coResponse?.forEach((item: any) => {
              if (item.type === "birth_or_citizenship_certificate")
                dataToStore.cocertificate = item.url;
              if (item.type === "medicare_card")
                dataToStore.comedicareCard = item.url;
            });
          }

          dispatch(
            addStepsData({
              ...others,
              passportVisaimages: dataToStore.passportVisaimages,
              cocertificate: dataToStore.cocertificate ?? storeCoCertificate,
              comedicareCard: dataToStore.comedicareCard ?? storeCoMedicareCard,
              validAustralianPassport: yourisValidPassport || false,
              covalidAustralianPassport: coisValidPassport || false,
            })
          );
          setIsLoading(false);
          dispatch(nextStep());
        } catch (error: any) {
          setIsLoading(false);
          toast.error(
            error?.response?.data?.message || "Something went wrong."
          );
        }
      }
    } else if (!(isCitizen && isCoCitizen)) {
      if (
        !(passport instanceof File) &&
        !(visa instanceof File) &&
        !(copassport instanceof File) &&
        !(covisa instanceof File)
      ) {
        dispatch(nextStep());
        return;
      }

      const yourUploadData: Record<string, File> = {};
      const coUploadData: Record<string, File> = {};
      const yourDocumentTypes: string[] = [];
      const coDocumentTypes: string[] = [];

      if (passport instanceof File) {
        yourDocumentTypes.push("passport");
        yourUploadData.passport = passport;
      }
      if (visa instanceof File) {
        yourUploadData.visa = visa;
        yourDocumentTypes.push("visa");
      }

      if (copassport instanceof File) {
        coDocumentTypes.push("passport");
        coUploadData.passport = copassport;
      }
      if (covisa instanceof File) {
        coDocumentTypes.push("visa");
        coUploadData.visa = covisa;
      }

      if (
        Object.keys(coUploadData).length === 0 &&
        Object.keys(yourUploadData).length === 0
      ) {
        dispatch(nextStep());
        return;
      }

      try {
        setIsLoading(true);
        let yourPresignedData: any = null;
        let coPresignedData: any = null;
        const presignedRequests: Promise<any>[] = [];

        if (yourDocumentTypes.length > 0) {
          presignedRequests.push(
            getPresignedUrlsPromise({
              url: `/document/${savedIds.applicantID}/presigned-urls`,
              data: { documentTypes: yourDocumentTypes },
            }).then((res) => {
              yourPresignedData = res;
            })
          );
        }
        if (coDocumentTypes.length > 0) {
          presignedRequests.push(
            getPresignedUrlsPromise({
              url: `/document/${savedIds.secondApplicantID}/presigned-urls`,
              data: { documentTypes: coDocumentTypes },
            }).then((res) => {
              coPresignedData = res;
            })
          );
        }

        await Promise.all(presignedRequests);

        const yourMetadata: Record<string, any> = {};
        const coMetadata: Record<string, any> = {};

        // Upload your driver's license
        if (passport instanceof File && yourPresignedData?.passport) {
          const { url, key } = yourPresignedData?.passport || {};
          await uploadToS3(url, passport);
          yourMetadata["passport"] = {
            key,
            fileName: passport.name,
            mimeType: passport.type,
          };
        }

        if (visa instanceof File && yourPresignedData?.visa) {
          const { url, key } = yourPresignedData?.visa || {};
          await uploadToS3(url, visa);
          yourMetadata["visa"] = {
            key,
            fileName: visa.name,
            mimeType: visa.type,
          };
        }

        if (copassport instanceof File && coPresignedData?.passport) {
          const { url, key } = coPresignedData?.passport || {};
          await uploadToS3(url, copassport);
          coMetadata["passport"] = {
            key,
            fileName: copassport.name,
            mimeType: copassport.type,
          };
        }

        if (covisa instanceof File && coPresignedData?.visa) {
          const { url, key } = coPresignedData?.visa || {};
          await uploadToS3(url, covisa);
          coMetadata["visa"] = {
            key,
            fileName: covisa.name,
            mimeType: covisa.type,
          };
        }
        const uploadRequests: Promise<any>[] = [];
        let hasYourUpload = Object.keys(yourMetadata).length > 0;
        let hasCoUpload = Object.keys(coMetadata).length > 0;

        if (Object.keys(yourMetadata).length > 0) {
          uploadRequests.push(
            uploadImages({
              url: `/document/${savedIds.applicantID}/visa-passport`,
              data: yourMetadata,
            })
          );
        }

        if (Object.keys(coMetadata).length > 0) {
          uploadRequests.push(
            uploadImages({
              url: `/document/${savedIds.secondApplicantID}/visa-passport`,
              data: coMetadata,
            })
          );
        }

        const uploadResponses = await Promise.all(uploadRequests);
        let yourResponse: any[] = [];
        let coResponse: any[] = [];

        if (hasYourUpload && hasCoUpload) {
          [yourResponse, coResponse] = uploadResponses;
        } else if (hasYourUpload) {
          [yourResponse] = uploadResponses;
        } else if (hasCoUpload) {
          [coResponse] = uploadResponses;
        }

        const passportVisaimagesURL: Record<string, string> = {
          ...(passportVisaimages || {}),
        };
        if (yourResponse?.length > 0) {
          yourResponse?.forEach((item: any) => {
            if (item.type === "passport") {
              passportVisaimagesURL.passport = item.url;
            } else if (item.type === "visa") {
              passportVisaimagesURL.visa = item.url;
            }
          });
        }
        // Process co-applicant response
        if (coResponse?.length > 0) {
          coResponse?.forEach((item: any) => {
            if (item.type === "passport") {
              passportVisaimagesURL.copassport = item.url;
            } else if (item.type === "visa") {
              passportVisaimagesURL.covisa = item.url;
            }
          });
        }

        dispatch(
          addStepsData({
            ...others,
            passportVisaimages: passportVisaimagesURL,
          })
        );

        dispatch(nextStep());
        setIsLoading(false);
      } catch (error: any) {
        setIsLoading(false);
        toast.error(error?.response?.data?.message || "Something went wrong.");
      }
    }
  };
  const uploadToS3 = (url: string, file: File) => {
    return new Promise<void>((resolve, reject) => {
      uploadS3(
        { url, data: file },
        {
          onSuccess: (status: any) => (status === 200 ? resolve() : reject()),
          onError: reject,
        }
      );
    });
  };

  const handleFileChooseClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const cohandleFileChooseClick = () => {
    if (cofileInputRef.current) {
      cofileInputRef.current.click();
    }
  };

  // Handle file selection

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null;
    clearErrors("passportImage");
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      setError("passportImage", {
        type: "fileSize",
        message: "File size should not exceed 5MB",
      });
      e.target.value = "";
      return;
    }

    if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
      setError("passportImage", {
        type: "fileType",
        message: "Invalid file type. Only JPG, PNG are allowed",
      });
      e.target.value = "";
      return;
    }
    setValue("passportImage", file, { shouldValidate: true });
    await trigger("passportImage");
  };

  const cohandleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null;
    clearErrors("copassportImage");
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      setError("copassportImage", {
        type: "fileSize",
        message: "File size should not exceed 5MB",
      });
      e.target.value = "";
      return;
    }

    if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
      setError("copassportImage", {
        type: "fileType",
        message: "Invalid file type. Only JPG, PNG are allowed",
      });
      e.target.value = "";
      return;
    }
    setValue("copassportImage", file, { shouldValidate: true });
    await trigger("copassportImage");
  };

  useEffect(() => {
    if (selectedFile instanceof File) {
      const objectUrl = URL.createObjectURL(selectedFile);
      setYourPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else if (storePassPortImage) {
      setYourPreview(storePassPortImage);
    }
  }, [selectedFile, storePassPortImage]);

  useEffect(() => {
    if (coselectedFile instanceof File) {
      const objectUrl = URL.createObjectURL(coselectedFile);
      setCoPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else if (storeCoPassPortImage) {
      setCoPreview(storeCoPassPortImage);
    }
  }, [coselectedFile, storeCoPassPortImage]);

  const handleDeleteImage = (type: any) => {
    if (type === "passportImage") {
      if (yourPreview) {
        URL.revokeObjectURL(yourPreview);
      }
      dispatch(
        addStepsData({
          ...others,
          passportImage: "",
        })
      );
      setYourPreview(null);
      setValue("passportImage", null);
    } else if (type === "copassportImage") {
      if (coPreview) {
        URL.revokeObjectURL(coPreview);
      }
      dispatch(
        addStepsData({
          ...others,
          copassportImage: "",
        })
      );
      setCoPreview(null);
      setValue("copassportImage", null);
    }
  };

  // if the I don't have a valid Australian Passport

  const [yourCitizenshipPreview, setCitizenshipPreview] = useState<
    string | null
  >(null);

  const [yourMedicareCardPreview, setmedicareCardPreview] = useState<
    string | null
  >(null);

  const [coCitizenshipPreview, setCoCitizenshipPreview] = useState<
    string | null
  >(null);
  const [coMedicareCardPreview, setCoMedicareCardPreview] = useState<
    string | null
  >(null);

  const certificate = watch("certificate");
  const medicareCard = watch("medicareCard");

  const cocertificate = watch("cocertificate");
  const comedicareCard = watch("comedicareCard");

  const certificateRef = useRef<HTMLInputElement>(null);
  const medicareCardRef = useRef<HTMLInputElement>(null);
  const cocertificateRef = useRef<HTMLInputElement>(null);
  const comedicareCardRef = useRef<HTMLInputElement>(null);

  const certificateHandleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0] ?? null;

    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      setError("certificate", {
        type: "fileSize",
        message: "File size should not exceed 5MB",
      });
      e.target.value = "";
      return;
    }

    if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
      setError("certificate", {
        type: "fileType",
        message: "Invalid file type. Only JPG, PNG are allowed",
      });
      e.target.value = "";
      return;
    }
    setValue("certificate", file, { shouldValidate: true });
    clearErrors("certificate");
    await trigger("certificate");
  };
  const cocertificateHandleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0] ?? null;
    clearErrors("cocertificate");
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      setError("cocertificate", {
        type: "fileSize",
        message: "File size should not exceed 5MB",
      });
      e.target.value = "";
      return;
    }

    if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
      setError("cocertificate", {
        type: "fileType",
        message: "Invalid file type. Only JPG, PNG are allowed",
      });
      e.target.value = "";
      return;
    }
    setValue("cocertificate", file, { shouldValidate: true });
    await trigger("cocertificate");
  };
  const medicareHandleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0] ?? null;
    clearErrors("medicareCard");
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      setError("medicareCard", {
        type: "fileSize",
        message: "File size should not exceed 5MB",
      });
      e.target.value = "";
      return;
    }

    if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
      setError("medicareCard", {
        type: "fileType",
        message: "Invalid file type. Only JPG, PNG are allowed",
      });
      e.target.value = "";
      return;
    }
    setValue("medicareCard", file, { shouldValidate: true });
    await trigger("medicareCard");
  };
  const comedicareHandleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0] ?? null;
    clearErrors("comedicareCard");
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      setError("comedicareCard", {
        type: "fileSize",
        message: "File size should not exceed 5MB",
      });
      e.target.value = "";
      return;
    }

    if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
      setError("comedicareCard", {
        type: "fileType",
        message: "Invalid file type. Only JPG, PNG are allowed",
      });
      e.target.value = "";
      return;
    }
    setValue("comedicareCard", file, { shouldValidate: true });
    await trigger("comedicareCard");
  };
  const certificateHandleDeleteImage = () => {
    setCitizenshipPreview(null);
    setValue("certificate", null);
    dispatch(
      addStepsData({
        ...others,
        certificate: "",
      })
    );
  };
  const cocertificateHandleDeleteImage = () => {
    setCoCitizenshipPreview(null);
    setValue("cocertificate", null);
    dispatch(
      addStepsData({
        ...others,
        cocertificate: "",
      })
    );
  };

  const medicareHandleDeleteImage = () => {
    setmedicareCardPreview(null);
    setValue("medicareCard", null);
    dispatch(
      addStepsData({
        ...others,
        medicareCard: "",
      })
    );
  };
  const comedicareHandleDeleteImage = () => {
    setCoMedicareCardPreview(null);
    setValue("comedicareCard", null);
    dispatch(
      addStepsData({
        ...others,
        comedicareCard: "",
      })
    );
  };

  const certificateFileChooseClick = () => {
    if (certificateRef.current) {
      certificateRef.current.click();
    }
  };
  const cocertificateFileChooseClick = () => {
    if (cocertificateRef.current) {
      cocertificateRef.current.click();
    }
  };
  const medicareFileChooseClick = () => {
    if (medicareCardRef.current) {
      medicareCardRef.current.click();
    }
  };
  const comedicareFileChooseClick = () => {
    if (comedicareCardRef.current) {
      comedicareCardRef.current.click();
    }
  };

  useEffect(() => {
    const images = {
      certificate,
      medicareCard,
      cocertificate,
      comedicareCard,
    };

    Object.entries(images).forEach(([key, file]) => {
      if (file instanceof File) {
        const objectUrl = URL.createObjectURL(file);

        // Set preview dynamically
        switch (key) {
          case "certificate":
            setCitizenshipPreview(objectUrl);
            break;
          case "medicareCard":
            setmedicareCardPreview(objectUrl);
            break;
          case "cocertificate":
            setCoCitizenshipPreview(objectUrl);
            break;
          case "comedicareCard":
            setCoMedicareCardPreview(objectUrl);
            break;
        }

        // Cleanup function to revoke object URLs
        return () => URL.revokeObjectURL(objectUrl);
      } else {
        // Fallback to existing stored image
        switch (key) {
          case "certificate":
            setCitizenshipPreview(storeCertificate || null);
            break;
          case "medicareCard":
            setmedicareCardPreview(storeMedicareCard || null);
            break;
          case "cocertificate":
            setCoCitizenshipPreview(storeCoCertificate || null);
            break;
          case "comedicareCard":
            setCoMedicareCardPreview(storeCoMedicareCard || null);
            break;
        }
      }
    });
  }, [
    certificate,
    medicareCard,
    cocertificate,
    comedicareCard,
    storeCertificate,
    storeMedicareCard,
    storeCoCertificate,
    storeCoMedicareCard,
  ]);

  useEffect(() => {
    if (
      yourisValidPassport ||
      validAustralianPassport ||
      certificate ||
      storeCertificate
    ) {
      clearErrors("passportImage");
    }
  }, [
    yourisValidPassport,
    validAustralianPassport,
    certificate,
    storeCertificate,
  ]);

  useEffect(() => {
    if (
      coisValidPassport ||
      covalidAustralianPassport ||
      cocertificate ||
      storeCoCertificate
    ) {
      clearErrors("copassportImage");
    }
  }, [
    coisValidPassport,
    covalidAustralianPassport,
    cocertificate,
    storeCoCertificate,
  ]);
  useEffect(() => {
    if (validAustralianPassport) {
      setYourIsValidPassport(true);
    }
  }, [validAustralianPassport]);

  useEffect(() => {
    if (covalidAustralianPassport) {
      setCoIsValidPassport(true);
    } else {
      clearErrors("comedicareCard");
      clearErrors("cocertificate");
    }
  }, [covalidAustralianPassport]);

  const handleYourValidAustralianPassport = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (validAustralianPassport && !e.target.checked) {
      dispatch(
        addStepsData({
          ...others,
          certificate: "",
          medicareCard: "",
          validAustralianPassport: false,
        })
      );
    }
  };
  const handleCoValidAustralianPassport = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (covalidAustralianPassport && !e.target.checked) {
      dispatch(
        addStepsData({
          ...others,
          cocertificate: "",
          comedicareCard: "",
          covalidAustralianPassport: false,
        })
      );
    }
  };

  //  ----- conduction base clear the error -----

  useEffect(() => {
    if (yourisValidPassport) {
      unregister("passportImage");
    } else {
      unregister("certificate");
      unregister("medicareCard");
    }
  }, [yourisValidPassport]);
  useEffect(() => {
    if (coisValidPassport) {
      unregister("copassportImage");
    } else {
      unregister("cocertificate");
      unregister("comedicareCard");
    }
  }, [coisValidPassport]);

  //  ----- end  conduction base clear the error -----

  return (
    <>
      {isLoading && (
        <Loader text="Please wait while your documents are being uploaded..." />
      )}
      <ProgressBar progress={72} MB={4} />
      <div className="w-full sm:w-[60%] lg:w-[50%] mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Legal Documents" />
        <SubTitle title="Please upload passport image" />
      </div>
      <div className="mx-auto w-internalWidth">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex mb-8 flex-col md:flex-col xl:flex-row gap-8 lg:gap-7 xl:gap-4 justify-between">
            <div className="w-full md:w-full lg:w-w-full xl:w-[49%]">
              <InfoTitle title="Your Details" />

              {visaStatus === "Citizen" ? (
                <>
                  <div className="text-left">
                    <h6 className="font-Mulish text-nowrap text-base text-lightBlue mb-2">
                      Upload passport image
                      <span className="text-danger">*</span>
                    </h6>
                    <HasValidAustralianPassport
                      isChecked={yourisValidPassport}
                      passportImage={yourPreview}
                      selectedFile={selectedFile}
                      setIsChecked={setYourIsValidPassport}
                      fieldName="passportImage"
                      clearErrors={clearErrors}
                      onChange={(e) => handleYourValidAustralianPassport(e)}
                    />
                  </div>
                  {!yourisValidPassport && (
                    <PassportImageUpload
                      previewUrl={yourPreview}
                      fieldName="passportImage"
                      register={register}
                      error={errors?.passportImage}
                      fileInputRef={fileInputRef}
                      handleFileChange={handleFileChange}
                      onChooseFileClick={handleFileChooseClick}
                      onDelete={handleDeleteImage}
                      savedFileUrl={storePassPortImage ?? ""}
                      imageObject={selectedFile}
                      isChecked={yourisValidPassport}
                    />
                  )}

                  {yourisValidPassport && (
                    <div className=" flex gap-7 sm:gap-4  flex-col lg:flex-row justify-between">
                      <FileUploadCard
                        label="Citizenship certificate or Birth Certificate"
                        description="Upload the front side of the document supports: JPG, PNG, PDF"
                        file={certificate}
                        filePreview={yourCitizenshipPreview}
                        register={register("certificate", {
                          required: !yourCitizenshipPreview
                            ? "File is required"
                            : false,
                        })}
                        error={errors.certificate?.message as string}
                        onFileChange={certificateHandleFileChange}
                        onFileChooseClick={certificateFileChooseClick}
                        onDelete={certificateHandleDeleteImage}
                        fileInputRef={certificateRef}
                      />
                      <FileUploadCard
                        label="Medicare card"
                        description="Upload the Back side of the document supports: JPG, PNG, PDF"
                        file={medicareCard}
                        filePreview={yourMedicareCardPreview}
                        register={register("medicareCard", {
                          required: !yourMedicareCardPreview
                            ? "File is required"
                            : false,
                        })}
                        error={errors.medicareCard?.message as string}
                        onFileChange={medicareHandleFileChange}
                        onFileChooseClick={medicareFileChooseClick}
                        onDelete={medicareHandleDeleteImage}
                        fileInputRef={medicareCardRef}
                      />
                    </div>
                  )}
                </>
              ) : (
                <PassportAndVisa
                  imageFields={[
                    {
                      label: "Passport image",
                      subTitle:
                        "Upload the front side of the document supports: JPG, PNG, PDF",
                      fieldName: "passport",
                      previewUrl: yourFrontPreview,
                      savedFileUrl: passportVisaimages?.passport,
                      error: errors.passport,
                      fileInputRef: frontFileInputRef,
                    },
                    {
                      label: "Visa application",
                      fieldName: "visa",
                      subTitle:
                        "Upload the Back side of the document supports: JPG, PNG, PDF",
                      previewUrl: yourBackPreview,
                      savedFileUrl: passportVisaimages?.visa,
                      error: errors.visa,
                      fileInputRef: backFileInputRef,
                    },
                  ]}
                  register={register}
                  watch={watch}
                  onFileChange={visaPassporthandleFileChange}
                  onChooseFile={visaPassporthandleFileChooseClick}
                  onDeleteImage={
                    visaPassportHandleDeleteImage as (fieldName: string) => void
                  }
                />
              )}
            </div>
            <div className="w-full md:w-full lg:w-w-full xl:w-[49%]">
              <InfoTitle title="Co-borrower" />
              {covisaStatus === "Citizen" ? (
                <>
                  <div className="text-left">
                    <h6 className="font-Mulish text-nowrap text-base text-lightBlue mb-2">
                      Upload passport image
                      <span className="text-danger">*</span>
                    </h6>

                    <HasValidAustralianPassport
                      isChecked={coisValidPassport}
                      passportImage={coPreview}
                      selectedFile={coselectedFile}
                      setIsChecked={setCoIsValidPassport}
                      fieldName="copassportImage"
                      clearErrors={clearErrors}
                      onChange={(e) => handleCoValidAustralianPassport(e)}
                    />
                  </div>
                  {!coisValidPassport && (
                    <PassportImageUpload
                      previewUrl={coPreview}
                      fieldName="copassportImage"
                      register={register}
                      error={errors?.copassportImage}
                      fileInputRef={cofileInputRef}
                      handleFileChange={cohandleFileChange}
                      onChooseFileClick={cohandleFileChooseClick}
                      onDelete={handleDeleteImage}
                      savedFileUrl={storeCoPassPortImage ?? ""}
                      imageObject={coselectedFile}
                      isChecked={coisValidPassport}
                    />
                  )}
                  {coisValidPassport && (
                    <div className="flex gap-7 sm:gap-4  flex-col lg:flex-row justify-between">
                      <FileUploadCard
                        label="Citizenship certificate or Birth Certificate"
                        description="Upload the front side of the document supports: JPG, PNG, PDF"
                        file={cocertificate}
                        filePreview={coCitizenshipPreview}
                        register={register("cocertificate", {
                          required: !coCitizenshipPreview
                            ? "File is required"
                            : false,
                        })}
                        error={errors.cocertificate?.message as string}
                        onFileChange={cocertificateHandleFileChange}
                        onFileChooseClick={cocertificateFileChooseClick}
                        onDelete={cocertificateHandleDeleteImage}
                        fileInputRef={cocertificateRef}
                      />
                      <FileUploadCard
                        label="Medicare card"
                        description="Upload the Back side of the document supports: JPG, PNG, PDF"
                        file={comedicareCard}
                        filePreview={coMedicareCardPreview}
                        register={register("comedicareCard", {
                          required: !coMedicareCardPreview
                            ? "File is required"
                            : false,
                        })}
                        error={errors.comedicareCard?.message as string}
                        onFileChange={comedicareHandleFileChange}
                        onFileChooseClick={comedicareFileChooseClick}
                        onDelete={comedicareHandleDeleteImage}
                        fileInputRef={comedicareCardRef}
                      />
                    </div>
                  )}
                </>
              ) : (
                <PassportAndVisa
                  imageFields={[
                    {
                      label: "Passport image",
                      subTitle:
                        "Upload the front side of the document supports: JPG, PNG, PDF",
                      fieldName: "copassport",
                      previewUrl: coFrontPreview,
                      savedFileUrl: passportVisaimages?.copassport,
                      error: errors.copassport,
                      fileInputRef: cofrontFileInputRef,
                    },
                    {
                      label: "Visa application",
                      subTitle:
                        "Upload the Back side of the document supports: JPG, PNG, PDF",
                      fieldName: "covisa",
                      previewUrl: coBackPreview,
                      savedFileUrl: passportVisaimages?.covisa,
                      error: errors.covisa,
                      fileInputRef: cobackFileInputRef,
                    },
                  ]}
                  register={register}
                  watch={watch}
                  onFileChange={visaPassportCohandleFileChange}
                  onChooseFile={visaPassportCohandleFileChooseClick}
                  onDeleteImage={
                    visaPassportHandleDeleteImage as (fieldName: string) => void
                  }
                />
              )}
            </div>
          </div>

          <div className="flex justify-between mb-6">
            <PreviousButtom
              onClick={() => {
                dispatch(prevStep());
              }}
            >
              Previous
            </PreviousButtom>
            <ContinueButton type="submit" loading={isLoading}>
              Next
            </ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default PartFive;
